import React, { useState } from "react";
import { Col, Row } from "react-bootstrap";
import * as i18n from "util/i18n";
import MainContainer from "pages/_components/MainContainer";
import Button from "pages/_components/Button";
import { TransactionCard, TransactionHeader } from "pages/_components/TransactionCard";
import { ResponsiveHeader } from "pages/_components/header";
import useReactPrint from "pages/_components/Print/useReactToPrint";
import { bool } from "prop-types";
import { actions as debinActions } from "reducers/debin";
import { useTransaction } from "hooks/useTransactions";
import Notification from "pages/_components/Notification";
import gaEventTracker, { events } from "util/gaEventTracker";
import EmitDebinSummaryBody from "./components/Summary";

const EmitDebinTransactionPage = ({ isDesktop }) => {
    const formatTransactionDebin = (data, idTransaction) => {
        const formData = {
            ...data,
            service: data.service,
            reference: data.reference,
            concept: data.concept,
            description: data.description,
            selectedAccount: {
                shortLabel: data.accountInfo,
                currency: data.currency,
                cbu: data.cbu,
            },
            beneficiary: data.beneficiary,
            beneficiaryName: data.beneficiaryName,
            productId: data.productId,
            emision: data.emision,
            shortLabel: data.sellerName,
            idTransaction,
        };
        return formData;
    };

    const [showMoreData, setShowMoreData] = useState();

    const {
        isLoading,
        transaction,
        dispatch,
        handleSignTransaction,
        showSignButton,
        push,
        id,
        status,
    } = useTransaction(
        "/debin/AddRecurence/confirm",
        debinActions.setdebinPrestacionData,
        debinActions.cleanDebinTicket,
        formatTransactionDebin,
    );
    const { componentRef, handlePrint, mobileRef, handleShareMobile } = useReactPrint(
        "debin.add.sucsesful",
        id,
        "echecks.emit",
    );

    const { isFinished, isBackoffice } = status;

    const handleSign = () => {
        gaEventTracker.triggerEvent(events.debin_adherir_recurrencia_firmar());
        return handleSignTransaction();
    };

    const handleDownload = async () => {
        await setShowMoreData(true);
        gaEventTracker.triggerEvent(events.debin_adherir_recurrencia_descargar());
        return handlePrint();
    };

    return (
        <>
            <Notification scopeToShow="debin.ticket.recurrency" />
            {!isBackoffice && <ResponsiveHeader ticket metaTitle="echecks.emit" />}
            <MainContainer showLoader={isLoading}>
                <div className="container" ref={componentRef}>
                    <div ref={mobileRef}>
                        <TransactionCard transaction={transaction}>
                            <TransactionHeader title="debin.add.sucsesful" />
                            <div className="ticket">
                                <div className="ticket__wrapper">
                                    <div
                                        className="ticket__header"
                                        style={{ marginBottom: isDesktop ? "-20px" : "0" }}
                                    />
                                    <EmitDebinSummaryBody
                                        showMoreData={showMoreData}
                                        setShowMoreData={setShowMoreData}
                                    />
                                    <div className="ticket__footer" data-copytext={i18n.get("global.ticketCopyText")} />
                                </div>
                            </div>
                        </TransactionCard>
                    </div>
                    {!isBackoffice && (
                        <Row className="form-actions no-print">
                            <Col xs={12} md={4} mdOffset={showSignButton || isFinished ? 2 : 4}>
                                <Button
                                    onClick={() => dispatch(push("/desktop"))}
                                    label="forms.transaction.ticket.actions.backToHome"
                                    className={`btn${showSignButton || isFinished ? " btn-outline" : " btn-primary"}`}
                                />
                            </Col>
                            {isFinished && (
                                <>
                                    <Col xs={12} md={4}>
                                        <Button
                                            onClick={handleDownload}
                                            image="images/download.svg"
                                            label="global.download"
                                            className="btn-primary"
                                        />
                                    </Col>
                                    {!isDesktop && (
                                        <Col xs={12} md={4}>
                                            <Button
                                                className="btn btn-outline"
                                                image="images/figma/icon/share.svg"
                                                label="global.share"
                                                onClick={() => {
                                                    handleShareMobile();
                                                }}
                                            />
                                        </Col>
                                    )}
                                </>
                            )}
                            {showSignButton && (
                                <Col xs={12} md={4}>
                                    <Button
                                        onClick={handleSign}
                                        label="forms.signTransaction.link"
                                        className="btn btn-primary"
                                    />
                                </Col>
                            )}
                        </Row>
                    )}
                </div>
            </MainContainer>
        </>
    );
};

EmitDebinTransactionPage.propTypes = {
    isDesktop: bool.isRequired,
};

export default EmitDebinTransactionPage;
